import styled from 'styled-components';

export const GoogleLogoStyle = styled.div`
    
    display: flex;
    justify-content: center;
    .google-logo {
        width: 50%;
    }

`